import { connect } from 'react-redux'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import Loader from 'components/D3Loader'
import { metadataActions, schedulerActions } from '../../../modules/Instrument'
import MetadataBuilderView from '../components/MetadataBuilderPage'
import { DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION } from 'utils/constants'

const mapStateToProps = ({ instrumentReducer, study, loading, user }, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const instrumentArchitectureVersion =
    study?.currentStudy?.config?.instrument_architecture_version || DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION
  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  // Instrument details/properties remain editable across DEV, UAT, and Live.
  // Schedule pages separately enforce read-only for UAT/Live.
  const isReadOnlyState = false

  return {
    instrument: instrumentReducer.instrument,
    confirmedSchedules: instrumentReducer.confirmedSchedules,
    instrumentArchitectureVersion,
    errors: instrumentReducer.errors,
    studyID: study.currentStudy.id,
    siteID: getBaseSiteIdFromStudy(study),
    loading: loading.general,
    userId: user?.id,
    study: study?.currentStudy,
    isReadOnlyState,
    studyVersionID,
    hasStudyPromotion,
  }
}

const mapDispatchToProps = {
  ...metadataActions,
  ...schedulerActions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  if (props.loading) {
    return Loader(props)
  }
  return MetadataBuilderView(props)
})
